/**
 * Order Details
 */

// React
import React, { useState, useEffect, useContext, useRef } from "react";

//UI
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import {
  Dialog,
  DialogContent,
  Typography,
  DialogActions,
  Paper,
  Grid,
  Button,
  CircularProgress,
  IconButton,
  TextField,
  DialogTitle,
} from "@material-ui/core";
import theme from "../../theme";

// Icon
import Icon from "@mdi/react";
import {
  mdiCalendar,
  mdiAccountOutline,
  mdiArrowRight,
  mdiClose,
  mdiPhoneOutline,
  mdiPrinter,
  mdiCounter,
  mdiCheck,
  mdiBarcodeScan,
  mdiCubeOutline,
  mdiLabel,
  mdiChevronDown,
} from "@mdi/js";

// Components
import ListOrderItems from "./list";
import PackageList from "./components/package";

// Rules

// Helper
import { translate, removeEmptyValueObject } from "../../utils/helpers";
import jMoment from "moment-jalaali";
import { useForm } from "react-hook-form";
// Type
import { Props, Item } from "./interfaces";
import { Link, useHistory } from "react-router-dom";
import OrderItemDetail from "./orderItemDetail";
import Modal from "../../components/Modal";
import handleError from "../../utils/handleError";
import handleNotfication from "../../utils/handleNotification";
import ordersRepository from "client-sdk/src/Repository/orders-repository";
import inventoryItemsRepository from "client-sdk/src/Repository/inventory-items-repository";
import orderPackagesRepository from "client-sdk/src/Repository/order-packages-repository";
import showDeliveryType from "../../utils/temporaryConditions/showDeliveryType";
import showOrderTplType from "../../utils/temporaryConditions/showOrderTplType";
import { Autocomplete } from "@material-ui/lab";
import getOrderFileReq from "client-sdk/src/orders/files";
import CustomizedItemCard from "../../components/Cards/customizedItemCard";
import { getBlockingTickets } from "../../api/ticket/get";
import CheckBoxList from "./checkBoxList";
import Can from "../../components/Can";

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      "& > *": {
        "@media (max-width: 768px)": {
          margin: theme.spacing(0),
        },
      },
    },
    paper: {
      // marginBottom: '24px',
      // paddingTop: theme.spacing(3),
      // paddingBottom: theme.spacing(3),
      // paddingLeft: theme.spacing(2),
      // paddingRight: theme.spacing(2),
      height: "100%",
      padding: theme.spacing(2),
      border: "1px solid #ddd",
      borderRadius: "4px",
      "@media (max-width: 768px)": {
        padding: theme.spacing(0),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(3),
        backgroundColor: theme.palette.background.default,
      },
    },
    addIcon: {
      textAlign: "center",
      position: "relative",
      paddingLeft: theme.spacing(8),
      // marginBottom: theme.spacing(7),
      "&::before": {
        content: '""',
        position: "absolute",
        width: "100px",
        top: "50%",
        left: "50%",
        transform: "translate(-50%,-50%)",
        height: "100px",
        borderRadius: "50%",
        opacity: "0.2",
        backgroundColor: "#5c5c5c",
      },
    },
    item: {
      display: "flex",
      alignSelf: "center",
      alignItems: "center",
      fontSize: "14px",
      fontWeight: 500,
    },
    icon: {
      marginRight: theme.spacing(1),
    },
    rtlIcon: {
      marginRight: theme.spacing(1),
      transform: "scale(-1, 1)",
    },
    divider: {
      width: "98%",
      margin: "10px auto",
    },
    label: {
      display: "flex",
      alignItems: "center",
      fontSize: "14px",
      fontWeight: 400,
      color: "#8A8A8A",
      marginRight: "10px",
    },
    headerBox: {
      display: "flex",
      alignItems: "center",
      marginBottom: "28px",
    },
    contentlabelTitle: {
      position: "relative",
      color: theme.palette.gray.light,
      marginLeft: "40px",
      fontSize: "14px",
      fontWeight: 500,
      "&:before": {
        content: '"-"',
        position: "absolute",
        left: "-20px",
      },
    },
    detail: {
      backgroundColor: "white",
      padding: "5px",
      width: "100%",
    },
    loading: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      height: "50vh",
      alignSelf: "center",
      justifyContent: "center",
      background: "#ccc",
    },
    changStatusIcon: {
      marginRight: "10px",
      position: "absolute",
    },
    changStatusBox: {
      display: "flex",
      textAlign: "left",

      fontWeight: 400,
      fontSize: "14px",
    },
    dot: {
      padding: 8,
      // marginRight: '10px',
      position: "relative",
      "&:before": {
        content: '""',
        position: "absolute",
        width: "1px",
        height: "80px",
        top: "4px",
        left: "-9px",
        backgroundColor: "#909090",
      },
    },
    renderValue: {
      paddingLeft: "32px",
    },
    radioGroup: {
      margin: "-8px 0",
    },
    radioGroupItem: {
      borderBottom: "1px solid #D8D8D8",
      marginRight: "-8px",
      padding: "8px 16px",
      "&:last-child": {
        borderBottom: "0px",
      },
    },
    cancelTitle: {
      fontSize: "16px",
      fontWeight: 500,
      textAlign: "justify",
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    editIcon: {
      textAlign: "center",
      position: "relative",
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      "&::before": {
        content: '""',
        position: "absolute",
        width: "100px",
        top: "50%",
        left: "50%",
        transform: "translate(-50%,-50%)",
        height: "100px",
        borderRadius: "50%",
        opacity: "0.2",
        backgroundColor: "#f30000",
      },
    },
    cancelIcon: {
      textAlign: "center",
      position: "relative",
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      "&::before": {
        content: '""',
        position: "absolute",
        width: "100px",
        top: "50%",
        left: "50%",
        transform: "translate(-50%,-50%)",
        height: "100px",
        borderRadius: "50%",
        opacity: "0.2",
        backgroundColor: theme.palette.error.main,
      },
    },
    checkIcon: {
      textAlign: "center",
      position: "relative",
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      "&::before": {
        content: '""',
        position: "absolute",
        width: "100px",
        top: "50%",
        left: "50%",
        transform: "translate(-50%,-50%)",
        height: "100px",
        borderRadius: "50%",
        opacity: "0.2",
        backgroundColor: "#039590",
      },
    },
    packageType: {
      backgroundColor: "#dfa01f",
      color: "#fff",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      height: "100px",
      borderRadius: "4px",
    },
    noPackage: {
      backgroundColor: "#D3D7E8",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      height: "100px",
      borderRadius: "4px",
    },
  })
);

export function Details(props: Props) {
  const history = useHistory();
  const [ticket, setTicket] = useState(null);
  const [serialNumber, setSerialNumber] = useState(false);
  const [barcodeSerial, setBarcodeSerial] = useState("");
  const [packageSerial, setPackageSerial] = useState("");
  const [openUnitItems, setOpenUnitItems] = useState(false as boolean);
  const [updateOrderItem, setUpdateOrderItem] = useState(false as boolean);
  const [openPackItems, setOpenPackItems] = useState(false as boolean);
  const [openDimensions, setOpenDimensions] = useState(false as boolean);
  const [dimensions, setDimensions] = useState<any>([]);
  const [openConfirmUpdateState, setOpenConfirmUpdateState] = useState(
    false as boolean
  );
  const [loading, setLoading] = useState(false);
  const [order, setOrder] = useState<any>({});
  const [inventoryCounts, setInventoryCounts] = useState({});
  const [orderPackages, setOrderPackage] = useState([]);
  const [inventoryItems, setInventoryItems] = useState([]);
  const [errorModal, setErrorModal] = useState<boolean>(false);
  const [checkedItems, setCheckedItems] = useState<string[]>([]);
  const [isValid, setIsValid] = useState(false);
  const [isCustomizedItems, setIsCustomizedItems] = useState(false);

  const [packageConfig, setPackageConfig] = useState<any>({
    id: 0,
    partnerId: 0,
    packageType: "PARTNER",
    customizedForAll: true,
    customizedItems: [],
    packageList: [],
  });
  const [customizedItems, setCustomizedItems] = useState<any>({
    CATALOG: [],
    VISIT_CARD: [],
    BRANDED_LABEL: [],
    GIFT_PACK: [],
    DISCOUNT_CARD: [],
  });

  const printBtn = useRef(null);
  const classes = useStyles();

  useEffect(() => {
    const filledItems = Object.keys(customizedItems).filter(
      (key) => customizedItems[key]?.length > 0
    );

    if (order?.receiptFileName) {
      filledItems.push("RECEPT_FILE_NAME");
    }

    const isValidItems =
      filledItems.length > 0 &&
      filledItems.every((item) => checkedItems.includes(item));

    setIsValid(isValidItems);

    filledItems.push("confirm");
    
  }, [checkedItems]);

  const handleCheckboxChange = (key: string, checked: boolean) => {
    if (key === "confirm" && isValid) {
      setOrderPackagedHandler();
    }
    setCheckedItems((prev) =>
      checked ? [...prev, key] : prev.filter((item) => item !== key)
    );
  };

  useEffect(() => {
    if (packageConfig.customizedItems.length > 0 || order.receiptFileName) {
      setIsCustomizedItems(true);
    } else {
      setIsCustomizedItems(false);
    }
  }, [packageConfig]);

  useEffect(() => {
    const { id } = props.match.params;
    // Commented out because of failure in production
    // getSuggestedPackages(id)
    orderWithId(id);
    orderPackageWithId(id);
    getInventoryItemsCount(id);
  }, []);

  useEffect(() => {
    order?.status === "PACKAGED" && history.push("/warehouse-operator-orders");
  }, [order]);

  useEffect(() => {
    let totalCount: any = 0;
    dimensions.forEach((dimension: any) => {
      totalCount += Number(dimension.count);
    });
  }, [dimensions]);

  useEffect(() => {
    if (barcodeSerial.length) {
      if (inventoryItems[0]?.id) {
        handleUpdateInventoryItems(inventoryItems[0]);
      } else {
        handleError({
          data: { message: "آیتم با سریال مورد نظر یافت نشد." },
        });
      }
    }
  }, [inventoryItems]);

  useEffect(() => {
    getTicket();
  }, []);

  const getTicket = async () => {
    const { id } = props.match.params;
    try {
      const res = await getBlockingTickets({
        serviceId: 2,
        linkType: "order",
        linkId: id,
        "status.notIn": "CLOSED",
      });
      setTicket(res.data[0]);
      res.data.length > 0 && handleNotfication("سفارش دارای تیکت است.", "warn");
    } catch (error) {
      handleError(error);
    }
  };

  const submitSerialPackage = (e: React.FormEvent) => {
    e.preventDefault();
    if (packageSerial === "print") {
      printBtn.current.click();
    } else {
      createOrderPackageHandler(packageSerial);
    }
  };

  const createOrderPackageHandler = async (orderPackageSerial: string) => {
    const { id } = props.match.params;
    const payload = {
      body: {
        orderId: id,
        packageSerial: orderPackageSerial.replace("P-", ""),
      },
      callback: () => {
        orderPackageWithId(id);
        orderWithId(id);
        getInventoryItemsCount(id);
      },
    };
    try {
      const { response, callback } =
        await orderPackagesRepository.createOrderPackage({ payload });
      callback && callback();
      setPackageSerial("");
      handleNotfication("بسته با موفقیت ایجاد شد", "success");
    } catch (error) {
      handleNotfication("بسته ایجاد نشد", "error");
    }
  };

  const orderWithId = async (id: any) => {
    const payload = { id };
    try {
      setLoading(true);
      const response = await ordersRepository.getOrderWithId({ payload });
      setOrder(response.data);
      getPackageConfig(response.data.partnerId);
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  const getPackageConfig = async (partnerId: string) => {
    try {
      const response = await ordersRepository.getOrderPackageConfigById({
        payload: { id: props.match.params.id },
      });
      let items = {
        CATALOG: [],
        VISIT_CARD: [],
        BRANDED_LABEL: [],
        GIFT_PACK: [],
        DISCOUNT_CARD: [],
      };
      if (response.data.customizedItems) {
        for (let i = 0; i < response.data.customizedItems.length; i++) {
          const item = response.data.customizedItems[i];
          items[item.customizedItemType].push(item);
        }
      }
      setCustomizedItems(items);
      setPackageConfig(response.data);
    } catch (err) {
      handleError(err);
    }
  };
  const orderPackageWithId = async (id: any) => {
    const payload = { id };
    try {
      setLoading(true);
      const { response } = await orderPackagesRepository.getOrderPackages({
        payload,
      });
      setOrderPackage(response.data);
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };
  const updateOrderStatus = async (action: any) => {
    try {
      const payload = { ...action };
      setLoading(true);
      const { pagination, callback } = await ordersRepository.updateOrderStatus(
        {
          payload,
        }
      );

      callback && callback();
      handleNotfication("تغییر وضعیت سفارش با موفقیت انجام شد", "success");
    } catch (error) {
      handleNotfication("تغییر وضعیت سفارش انجام نشد", "error");
    } finally {
      setLoading(false);
    }
  };
  const changeStatusOrder = (status: string) => {
    const { id } = props.match.params;
    updateOrderStatus({
      id: order.id,
      body: {
        status: status ?? "PACKAGED".replace(/"/g, ""),
      },
      pagination: {},
      callback: () => orderWithId(id),
    });
    handleClose();
    orderWithId(id);
  };
  const addOrderDimensions = async (action: any) => {
    try {
      const payload = { ...action };
      setLoading(true);
      const callback = await ordersRepository.addOrderDimensions({ payload });
      callback && callback();
      handleNotfication("تغییر وضعیت سفارش با موفقیت انجام شد", "success");
    } catch (error) {
      handleNotfication("تغییر وضعیت سفارش انجام نشد", "error");
    } finally {
      setLoading(false);
    }
  };
  const addOrderDimension = () => {
    const { id } = props.match.params;
    addOrderDimensions({
      id: order.id,
      body: dimensions,
      callback: () => orderWithId(id),
    });
    handleClose();
    orderWithId(id);
  };
  const handleChangeOrderStatus = () => {
    if (!!ticket) {
      handleNotfication(
        "برای این سفارش تیکت ثبت شده به سابقه تیکت بروید.",
        "error"
      );
      return null;
    }
    const notPackagedOrderItems = order?.items?.filter(
      (item) => item.status !== "PACKAGED"
    );
    if (notPackagedOrderItems.length === 0) {
      setOpenDimensions(true);
    } else {
      setOpenPackItems(true);
    }
  };
  const handleUpdateInventoryItems = (item: any) => {
    updateInventoryItems(item.id);
  };
  const updateInventoryItemsStatus = async (action: any) => {
    try {
      const payload = { ...action };
      setLoading(true);
      const callback =
        await inventoryItemsRepository.updateInventoryItemsChecked({ payload });
      handleNotfication("وضعیت آیتم مورد نظر با موفقیت تغییر کرد ", "success");
      callback && callback();
    } catch (error) {
      handleError(error.response);
    } finally {
      setLoading(false);
    }
  };
  const getInventoryItemsCount = (orderId: number) => {
    getInventoryItemsCountAction({
      packaged: {
        "orderId.equals": orderId,
        "orderPackageId.specified": true,
      },
      nPackaged: {
        "orderId.equals": orderId,
        "orderPackageId.specified": false,
      },
      count: {
        "orderId.equals": orderId,
      },
    });
  };
  const getInventoryItemsCountAction = async (action: any) => {
    try {
      const payload = { ...action };
      setLoading(true);
      const packagedInventory =
        await inventoryItemsRepository.getInventoryItemCount(payload.packaged);
      const notPackagedInventory =
        await inventoryItemsRepository.getInventoryItemCount(payload.nPackaged);
      const countOfInventory =
        await inventoryItemsRepository.getInventoryItemCount(payload.count);
      setInventoryCounts({
        packagedInventory,
        notPackagedInventory,
        countOfInventory,
      });
    } catch (error) {
      handleError(error.response);
    } finally {
      setLoading(false);
    }
  };
  const updateInventoryItems = (id: number) => {
    const orderId = props.match.params.id;
    updateInventoryItemsStatus({
      id: id,
      body: { orderId },
      page: 0,
      size: 10,
      callback: () => {
        setUpdateOrderItem(!updateOrderItem);
        setSerialNumber(!serialNumber);
        orderWithId(orderId);
      },
    });
  };
  const getInventoryItems = async (actions: any) => {
    try {
      setLoading(true);
      const { response, callback } =
        await inventoryItemsRepository.getInventoryItems({ payload: actions });
      setInventoryItems(response.data.content);
      callback && callback();
    } catch (error) {
      handleError(error.response);
    } finally {
      setLoading(false);
    }
  };
  const getInventoryItemsAction = (serial: string) => {
    const orderId = props.match.params.id;
    getInventoryItems({
      serialNumber: { equals: serial },
      orderId: { equals: orderId },
      page: 0,
      size: 10,
      callback: () => {},
    });
  };
  const getInventoryItemsActionFunc = (serial: string) => {
    setBarcodeSerial(serial);
    getInventoryItemsAction(serial);
  };
  const handleCloseErrorDialog = () => {
    setErrorModal(false);
  };
  const handleChangeStatus = () => {
    setOpenUnitItems(true);
  };
  const handleClose = () => {
    setOpenConfirmUpdateState(false);
    handleCloseDimensions();
  };
  const handleCloseDimensions = () => {
    setOpenDimensions(false);
    setDimensions([]);
  };
  const handleCloseUnitModal = () => {
    setOpenUnitItems(false);
  };
  const handleClosePickModal = () => {
    setOpenPackItems(false);
  };
  const addInventoryItemHandler = async (
    packageData: any,
    inventoryItemSerial: any
  ) => {
    const payload = {
      body: {
        orderId: packageData.orderId,
        inventoryItemSerialNumber: inventoryItemSerial,
      },
      callback: () => {
        orderPackageWithId(packageData.orderId);
        orderWithId(packageData.orderId);
        getInventoryItemsCount(packageData.orderId);
      },
      id: packageData.id,
    };
    try {
      const { response, callback } =
        await orderPackagesRepository.setInventoryItem({ payload });

      callback && callback();
      handleNotfication("آیتم به بسته اضافه شد", "success");
    } catch (error) {
      //  handleNotfication('آیتم به بسته اضافه نشد', 'error');
      setErrorModal(true);
    }
  };
  const removeInventoryHandler = async (
    packageId: any,
    inventorySerial: any
  ) => {
    const { id } = props.match.params;
    const payload = {
      body: {
        orderId: id,
        inventoryItemSerialNumber: inventorySerial,
      },
      callback: () => {
        orderPackageWithId(id);
        orderWithId(id);
        getInventoryItemsCount(id);
      },
      id: packageId,
    };
    try {
      const { response, callback } =
        await orderPackagesRepository.removeInventoryItem({ payload });

      callback && callback();
      handleNotfication("آیتم با موفقیت حذف شد", "success");
    } catch (error) {
      handleNotfication("آیتم حذف نشد", "error");
    }
  };
  const setConsumableHandler = async (
    amount: number,
    consumableId: number,
    packageId: any
  ) => {
    const { id } = props.match.params;
    const payload = {
      body: {
        amount: amount,
        consumableId: consumableId,
      },
      callback: () => {
        orderPackageWithId(id);
        orderWithId(id);
        getInventoryItemsCount(id);
      },
      id: packageId,
    };
    try {
      const { response, callback } =
        await orderPackagesRepository.setConsumables({ payload });
      callback && callback();
      handleNotfication("ماده مصرفی با موفقیت ثبت شد", "success");
    } catch (error) {
      handleNotfication("ماده مصرفی ثبت نشد", "error");
    }
  };
  const deleteOrderPackageHandler = async (orderPackageId: number) => {
    const { id } = props.match.params;
    const payload = {
      callback: () => {
        orderPackageWithId(id);
        orderWithId(id);
        getInventoryItemsCount(id);
      },
      id: orderPackageId,
    };
    try {
      const { response, callback } =
        await orderPackagesRepository.removeOrderPackage({ payload });
      callback && callback();
      handleNotfication("جعبه با موفقیت حذف شد", "success");
    } catch (error) {
      handleNotfication("جعبه حذف نشد", "error");
    }
  };
  const setOrderPackagedHandler = async () => {
    const { id } = props.match.params;
    const payload = {
      id: id,
    };
    printBtn.current.click();
    try {
      const { response, callback } =
        await orderPackagesRepository.setOrderPackaged({ payload });
      history.push("/warehouse-operator-orders");
      handleNotfication("فرایند بسته بندی با موفقیت انجام شد", "success");
    } catch (error) {
      handleNotfication("فرایند بسته بندی انجام نشد", "error");
    }
  };
  const getOrderFile = async (type: string) => {
    try {
      const response = await getOrderFileReq(order.id, { fileType: type });
      const file = URL.createObjectURL(response.blob);
      return file;
    } catch (error: any) {
      handleError(error);
      return error;
    }
  };

  const downLoadFile = async (type: string, fileName: string) => {
    try {
      const file = await getOrderFile(type);
      const link = document.createElement("a");
      link.href = file;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (error: any) {
      //   handleError(error)
    }
  };

  return (
    <div className={classes.root}>
      <div className={classes.headerBox}>
        <Typography variant="h6" component="h2">
          {`
        جزيیات سفارش
     
        `}
        </Typography>
        <span className={classes.contentlabelTitle}>{order.id}</span>
      </div>

      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center">
        <Button
          aria-label="details"
          size="medium"
          onClick={() => window.history.back()}>
          <Icon path={mdiArrowRight} size={1} className={classes.icon} />
          {"بازگشت"}
        </Button>

        <Grid spacing={2}>
          {order.receiptUrl && (
            <a
              href={`${order.receiptUrl}`}
              target="_blank"
              style={{ textDecoration: "none", marginLeft: "10px" }}>
              <Button
                variant="contained"
                color="secondary"
                startIcon={<Icon path={mdiPrinter} size={1} />}>
                {"چاپ فاکتور سفارش"}
              </Button>
            </a>
          )}
          {order.fulfillmentAttachmentUrl && (
            <a
              href={`${order.fulfillmentAttachmentUrl}`}
              target="_blank"
              style={{ textDecoration: "none" }}>
              <Button
                variant="contained"
                color="secondary"
                startIcon={<Icon path={mdiLabel} size={1} />}>
                {"چاپ لیبل های سفارش"}
              </Button>
            </a>
          )}
          {order.receiptFileName && order?.status !== "CANCELLED" && (
            <Button
              variant="contained"
              color="secondary"
              startIcon={<Icon path={mdiPrinter} size={1} />}
              onClick={() => downLoadFile("RECEIPT", order.receiptFileName)}>
              دانلود فایل فاکتور
            </Button>
          )}
          {order.labelFileName && order?.status !== "CANCELLED" && (
            <Button
              variant="contained"
              color="secondary"
              startIcon={<Icon path={mdiLabel} size={1} />}
              onClick={() => downLoadFile("LABEL", order.labelFileName)}>
              دانلود فایل لیبل
            </Button>
          )}
          <Link
            to={`/orders/exit-receipts/${order.id}?from=pack`}
            target="_blank"
            style={{ textDecoration: "none", margin: "0px 10px" }}>
            <Button
              variant="contained"
              color="secondary"
              startIcon={<Icon path={mdiPrinter} size={1} />}
              ref={printBtn}>
              {"چاپ رسید خروج"}
            </Button>
          </Link>
          {/* <Can 
            perform='orderExit:print'
            yes={() => (
            <Link
              to={`/orders/exit-receipts/${order.id}?from=pack`}
              target="_blank"
              style={{ textDecoration: 'none', margin: '0px 10px' }}
            >
              <Button
                variant="contained"
                color="secondary"
                startIcon={<Icon path={mdiPrinter} size={1} />}
                ref={printBtn}
              >
                {'چاپ رسید خروج'}
              </Button>
            </Link>
            )}
            no={() => (
              <Link
                to={`/orders/exit-receipts/${order.id}?from=pack`}
                target="_blank"
                style={{ display: 'none' }}
              >
                <Button
                  variant="contained"
                  color="secondary"
                  startIcon={<Icon path={mdiPrinter} size={1} />}
                  ref={printBtn}
                >
                </Button>
              </Link>
            )}
          /> */}
          <Button
            aria-label="register-parcel"
            onClick={() => handleChangeOrderStatus()}
            disabled={!!ticket}
            color="primary"
            variant="contained">
            {/* <Icon path={mdiCheck} size={1} /> */}
            <span style={{ paddingRight: "5px" }}>
              {"تایید بسته بندی سفارش"}
            </span>
          </Button>
          {ticket && (
            <Button
              variant="contained"
              color="primary"
              style={{ marginRight: "20px" }}
              onClick={() => {
                history.push(`/ticketing/${ticket?.id}`);
              }}>
              سابقه تیکت
            </Button>
          )}
        </Grid>
      </Grid>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          rowGap: "24px",
          backgroundColor: "#fff",
          padding: "24px",
          marginTop: "24px",
        }}>
        <Paper
          elevation={3}
          className={classes.paper}
          variant="elevation"
          square>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={3}>
              <div className={classes.item}>
                <span className={classes.label}>
                  <Icon
                    path={mdiAccountOutline}
                    size={1}
                    className={classes.icon}
                  />
                  {"نام تحویل گیرنده:  "}
                </span>

                <span>{order.customerName}</span>
              </div>
            </Grid>
            <Grid item xs={12} sm={3}>
              <div className={classes.item}>
                <span className={classes.label}>
                  <Icon
                    path={mdiPhoneOutline}
                    size={1}
                    className={classes.rtlIcon}
                  />
                  {"نام شرکت:  "}
                </span>
                <span>{order.partnerName}</span>
              </div>
            </Grid>
            <Grid item xs={12} sm={3}>
              <div className={classes.item}>
                <span className={classes.label}>
                  <Icon path={mdiCounter} size={1} />
                  {"تعداد آیتم های سفارش:  "}
                </span>
                <span>{order?.items?.length}</span>
              </div>
            </Grid>
            <Grid item xs={12} sm={3}>
              <div className={classes.item}>
                <span className={classes.label}>
                  <Icon path={mdiCalendar} size={1} className={classes.icon} />
                  {"زمان تحویل سفارش:  "}
                </span>
                <span>
                  {order.deliveryDate &&
                    `${jMoment(order.deliveryDate, "YYYY/MM/DD")
                      .locale("fa")
                      .format("jYYYY/jMM/jDD")}`}
                </span>
                <span style={{ padding: "0 10px" }}>-</span>
                <span>
                  {order.deliveryStartTime &&
                    order.deliveryEndTime &&
                    `${jMoment(order.deliveryStartTime, "hh:mm:ss")
                      .locale("fa")
                      .format("HH:mm")} تا 
                  ${jMoment(order.deliveryEndTime, "hh:mm:ss")
                    .locale("fa")
                    .format("HH:mm")}`}
                </span>
              </div>
            </Grid>
            <Grid item xs={12} sm={3}>
              <div className={classes.item}>
                <span className={classes.label}>
                  {/* <Icon path={mdiCalendar} size={1} className={classes.icon} /> */}
                  {"کد پیگیری سفارش:  "}
                </span>
                <span>{order.trackingCode}</span>
              </div>
            </Grid>
            <Grid item xs={12} sm={3}>
              <div className={classes.item}>
                <span className={classes.label}>
                  {/* <Icon path={mdiCalendar} size={1} className={classes.icon} /> */}
                  {"نوع پردازش:  "}
                </span>
                <span>{showDeliveryType(order.deliveryType)}</span>
              </div>
            </Grid>
            <Grid item xs={12} sm={2}>
              <div className={classes.item}>
                <span className={classes.label}>
                  {/* <Icon path={mdiCalendar} size={1} className={classes.icon} /> */}
                  {"ناوگان حمل:  "}
                </span>
                <span>
                  {showOrderTplType(order.deliveryType, order.orderTplType)}
                </span>
              </div>
            </Grid>
            <Grid item xs={12} sm={2}>
              <div className={classes.item}>
                <span className={classes.label}>
                  {/* <Icon path={mdiCalendar} size={1} className={classes.icon} /> */}
                  {"شهر:  "}
                </span>
                <span>{order?.customerCity}</span>
              </div>
            </Grid>
            <Grid item xs={12} sm={2}>
              <div className={classes.item}>
                <span className={classes.label}>
                  {/* <Icon path={mdiCalendar} size={1} className={classes.icon} /> */}
                  {"استان:  "}
                </span>
                <span>{order?.customerProvince}</span>
              </div>
            </Grid>
          </Grid>
        </Paper>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={2}>
            <div
              className={
                packageConfig?.packageType === "RONAD" &&
                (packageConfig?.customizedItems?.length === 0 ||
                  !packageConfig?.customizedItems)
                  ? classes.noPackage
                  : classes.packageType
              }>
              <span
                style={{
                  marginLeft: "10px",
                  fontSize: "16px",
                  fontWeight: "bold",
                }}>
                {/* <Icon path={mdiCalendar} size={1} className={classes.icon} /> */}
                {"بسته بندی:  "}
              </span>
              <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                {translate(packageConfig?.packageType, "packaging")}
              </span>
            </div>
          </Grid>
          <Grid item xs={12} sm={2}>
            <CustomizedItemCard
              label="کاتالوگ و بروشور"
              icon="catalog.png"
              items={customizedItems?.CATALOG}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <CustomizedItemCard
              label="لیبل"
              icon="label.png"
              items={customizedItems?.BRANDED_LABEL}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <CustomizedItemCard
              label="کارت ویزیت"
              icon="visit.png"
              items={customizedItems?.VISIT_CARD}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <CustomizedItemCard
              label="کارت تخفیف"
              icon="discount.png"
              items={customizedItems?.DISCOUNT_CARD}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <CustomizedItemCard
              label="پک هدیه"
              icon="gift.png"
              items={customizedItems?.GIFT_PACK}
            />
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={12}>
            {loading ? (
              <div className={classes.loading}>
                <CircularProgress />
              </div>
            ) : (
              order?.items && (
                <ListOrderItems
                  packItem={(serial) => getInventoryItemsActionFunc(serial)}
                  data={order.items}
                  serialNumber={serialNumber}
                  setOpenUnits={handleChangeStatus}
                />
              )
            )}
          </Grid>
        </Grid>
        <Grid container alignItems="stretch" spacing={3}>
          <Grid item xs={3}>
            <Paper
              elevation={3}
              className={classes.paper}
              variant="elevation"
              square>
              <Grid container>
                <Grid item xs={12}>
                  <form
                    onSubmit={submitSerialPackage}
                    style={{ width: "100%" }}>
                    <Autocomplete
                      id="driverName"
                      noOptionsText="موردی یافت نشد"
                      // disableClearable
                      onChange={(event: any, newValue: any | null) => {
                        if (newValue.code) {
                          setPackageSerial(newValue.code);
                        }
                      }}
                      freeSolo
                      getOptionSelected={(option, value) =>
                        option.code === value.code
                      }
                      getOptionLabel={(options) => options.code}
                      renderOption={(option) => (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            borderBottom: "1px solid #ededed",
                            width: "100%",
                            padding: "5px 0",
                          }}>
                          <p>{option.name}</p>
                          <span style={{ fontSize: "14px", color: "#b4b4b4" }}>
                            {option.code}
                          </span>
                        </div>
                      )}
                      options={packageConfig.packageList?.filter(
                        (el) => el.status === "ACTIVE"
                      )}
                      // loading={props.driversLoading}
                      loadingText="در حال بارگذاری"
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          margin="normal"
                          placeholder="اسکن شماره سریال بسته بندی"
                          autoFocus
                          onChange={(e) => setPackageSerial(e.target.value)}
                          InputProps={{
                            ...params.InputProps,
                            type: "search",
                            startAdornment: (
                              <Icon
                                path={mdiBarcodeScan}
                                size={1.5}
                                color="black"
                              />
                            ),
                            endAdornment: (
                              <React.Fragment>
                                <Icon
                                  path={mdiChevronDown}
                                  size={1}
                                  color="black"
                                />
                              </React.Fragment>
                            ),
                          }}
                        />
                      )}
                    />
                    <input type="submit" style={{ display: "none" }} />
                  </form>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
          <Grid item xs={9}>
            <Paper
              elevation={3}
              className={classes.paper}
              variant="elevation"
              square>
              <Grid container style={{ height: "100%" }}>
                <Grid item xs={3} style={{ padding: "8px" }}>
                  <Grid container>
                    <span
                      style={{
                        textAlign: "center",
                        margin: "5px auto",
                        fontSize: "16px",
                        color: "#707070",
                        padding: "5px",
                      }}>
                      {"آیتم های انبار"}
                    </span>
                    <span
                      style={{
                        textAlign: "center",
                        margin: "5px 0 5px auto",
                        fontSize: "24px",
                        color: "#080808",
                      }}>
                      {/* {order?.items?.length} */}
                      {inventoryCounts?.countOfInventory?.response?.data}
                    </span>
                  </Grid>
                </Grid>
                <Grid item xs={3} style={{ padding: "8px" }}>
                  <Grid container>
                    <span
                      style={{
                        textAlign: "center",
                        margin: "5px auto",
                        fontSize: "16px",
                        color: "#707070",
                        padding: "5px",
                      }}>
                      {"آیتم های پک شده"}
                    </span>
                    <span
                      style={{
                        textAlign: "center",
                        margin: "5px 0 5px auto",
                        fontSize: "24px",
                        color: "#080808",
                      }}>
                      {/* {order?.items?.filter(item => item.status === 'PACKAGED').length} */}
                      {inventoryCounts?.packagedInventory?.response?.data}
                    </span>
                  </Grid>
                </Grid>
                <Grid item xs={3} style={{ padding: "8px" }}>
                  <Grid container>
                    <span
                      style={{
                        textAlign: "center",
                        margin: "5px auto",
                        fontSize: "16px",
                        color: "#707070",
                        padding: "5px",
                      }}>
                      {"آیتم های باقی مانده"}
                    </span>
                    <span
                      style={{
                        textAlign: "center",
                        margin: "5px 0 5px auto",
                        fontSize: "24px",
                        color: "#080808",
                      }}>
                      {/* {order?.items?.length-order?.items?.filter(item => item.status === 'PACKAGED').length} */}
                      {inventoryCounts?.notPackagedInventory?.response?.data}
                    </span>
                  </Grid>
                </Grid>
                <Grid item xs={3} style={{ padding: "8px" }}>
                  <Grid container>
                    <span
                      style={{
                        textAlign: "center",
                        margin: "5px auto",
                        fontSize: "16px",
                        color: "#707070",
                        padding: "5px",
                      }}>
                      {"تعداد بسته بندی"}
                    </span>
                    <span
                      style={{
                        textAlign: "center",
                        margin: "5px 0 5px auto",
                        fontSize: "24px",
                        color: "#080808",
                      }}>
                      {orderPackages.length}
                    </span>
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            {loading ? (
              <div className={classes.loading}>
                <CircularProgress />
              </div>
            ) : (
              orderPackages.length > 0 &&
              orderPackages.map((orderPackage, index) => {
                return (
                  <PackageList
                    packItem={(serial) => getInventoryItemsActionFunc(serial)}
                    data={orderPackage}
                    print={() => printBtn.current.click()}
                    confirm={handleChangeOrderStatus}
                    serialNumber={serialNumber}
                    setOpenUnits={handleChangeStatus}
                    addPackage={createOrderPackageHandler}
                    addInventoryItemHandler={addInventoryItemHandler}
                    removeInventoryHandler={removeInventoryHandler}
                    setConsumableHandler={setConsumableHandler}
                    deleteOrderPackageHandler={deleteOrderPackageHandler}
                  />
                );
              })
            )}
          </Grid>
        </Grid>
      </div>

      <Dialog
        fullWidth
        open={openConfirmUpdateState}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title">
        <DialogContent>
          <div
            style={{
              position: "absolute",
              left: "17px",
              zIndex: 10,
            }}>
            {handleClose ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleClose}>
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.checkIcon}>
            <Icon path={mdiCheck} size={4} color="#039590" />
          </div>
          <div className={classes.cancelTitle}>
            {`از تغییر وضعیت سفارش
        به
       بسته‌بندی شده برای مشتری
        مطمئن هستید؟`}
          </div>
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <Button
                fullWidth
                autoFocus
                onClick={addOrderDimension}
                variant="contained"
                color="secondary"
                size="large">
                {"بله"}
              </Button>
            </Grid>
            <Grid item xs={4}>
              <Button
                fullWidth
                variant="contained"
                onClick={() => handleClose()}
                size="large">
                {"خیر"}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth
        open={openDimensions}
        onClose={handleCloseDimensions}
        aria-labelledby="responsive-dialog-title">
        <DialogContent>
          <div
            style={{
              position: "absolute",
              left: "17px",
              zIndex: 10,
            }}>
            {handleCloseDimensions ? (
              <IconButton aria-label="close" onClick={handleCloseDimensions}>
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.checkIcon}>
            <Icon path={mdiCubeOutline} size={4} color="#039590" />
          </div>
          <Grid container spacing={1} alignItems="flex-end">
            <Grid item xs={12}>
              {isCustomizedItems ? (
                <h3>{"سفارش دارای آیتم‌های زیر است:"}</h3>
              ) : (
                <h3>{"آیا از بسته بندی سفارش ها اطمینان دارید؟"}</h3>
              )}
            </Grid>
          </Grid>
          {isCustomizedItems && (
            <CheckBoxList
              onCheckboxChange={handleCheckboxChange}
              customizedItems={customizedItems}
              receiptFileName={order?.receiptFileName}
              checkedItems={checkedItems}
              setIsValid={setIsValid}
              isValid={isValid}
            />
          )}
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <Button
                fullWidth
                autoFocus
                disabled={!(isValid || !isCustomizedItems)}
                onClick={() => setOrderPackagedHandler()}
                variant="contained"
                color="secondary"
                size="large">
                {"تایید"}
              </Button>
            </Grid>
            <Grid item xs={4}>
              <Button
                fullWidth
                variant="contained"
                onClick={() => handleCloseDimensions()}
                size="large">
                {"بستن"}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Modal
        onClose={handleCloseUnitModal}
        maxWidth="lg"
        open={openUnitItems}
        title={
          <div className={classes.addIcon}>
            <Icon path={mdiBarcodeScan} size={4} color="#5c5c5c" />
          </div>
        }
        content={
          <OrderItemDetail
            onClose={handleCloseUnitModal}
            serialNumber={serialNumber}
            packItem={(serial) => getInventoryItemsActionFunc(serial)}
          />
        }
      />
      <Dialog
        fullWidth
        open={openPackItems}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title">
        <DialogContent>
          <div
            style={{
              position: "absolute",
              left: "17px",
              zIndex: 10,
            }}>
            <IconButton
              aria-label="close"
              // className={classes.closeButton}
              onClick={handleClosePickModal}>
              <Icon path={mdiClose} size={1} />
            </IconButton>
          </div>
          <div className={classes.editIcon}>
            <Icon path={mdiClose} size={4} color="#f30000" />
          </div>
          <div className={classes.cancelTitle}>
            {`تمام کالاها به لیست اضافه نشده اند`}
          </div>
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <Button
                fullWidth
                autoFocus
                onClick={handleClosePickModal}
                variant="contained"
                color="secondary"
                size="large">
                {"بررسی مجدد"}
              </Button>
            </Grid>
            <Grid item xs={4}>
              <Button
                fullWidth
                variant="contained"
                onClick={() => changeStatusOrder("CONFLICTED")}
                size="large">
                {"ایجاد مغایرت"}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth
        open={errorModal}
        onClose={handleCloseErrorDialog}
        aria-labelledby="responsive-dialog-title">
        <DialogTitle>
          <div
            style={{
              position: "absolute",
              left: "17px",
              zIndex: 10,
            }}>
            {handleCloseErrorDialog ? (
              <IconButton aria-label="close" onClick={handleCloseErrorDialog}>
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.cancelIcon}>
            <Icon path={mdiClose} size={4} color={theme.palette.error.main} />
          </div>
          <div className={classes.cancelTitle}>
            <div className={classes.cancelTitle}>{"سریال آیتم اشتباه"}</div>
          </div>
        </DialogTitle>
        <DialogActions>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Button
                fullWidth
                onClick={handleCloseErrorDialog}
                variant="contained"
                color="secondary"
                size="large">
                {"متوجه شدم"}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default Details;
